function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fillRule: "nonzero",
  d: "M0 0h12v12H0z"
}), React.createElement("path", {
  fill: "#595959",
  d: "M10.6 9.773a4.466 4.466 0 0 0-.96-1.422 4.466 4.466 0 0 0-1.978-1.153 3.685 3.685 0 0 0 1.427-.889 3.673 3.673 0 0 0 1.083-2.613c0-.986-.384-1.915-1.083-2.613A3.673 3.673 0 0 0 6.476 0C5.49 0 4.561.384 3.863 1.083A3.673 3.673 0 0 0 2.78 3.696c0 .987.384 1.915 1.083 2.613.408.408.895.709 1.427.889A4.466 4.466 0 0 0 3.312 8.35 4.466 4.466 0 0 0 2 11.517a.483.483 0 1 0 .966 0c0-.938.365-1.82 1.028-2.483a3.488 3.488 0 0 1 2.483-1.028c.939 0 1.82.365 2.483 1.028a3.488 3.488 0 0 1 1.028 2.483.483.483 0 1 0 .967 0 4.503 4.503 0 0 0-.355-1.744zM3.745 3.696a2.733 2.733 0 0 1 2.73-2.73 2.733 2.733 0 0 1 2.73 2.73 2.732 2.732 0 0 1-2.73 2.73 2.733 2.733 0 0 1-2.73-2.73z"
}));

var SvgIcGender = function SvgIcGender(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcGender, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-gender.318a706a.svg";
export { ForwardRef as ReactComponent };